<!-- 検索メニュー タイトルバー -->
<template>
  <div class="crly-a-common-search-title">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "CrlyAtomsCommonSearchTitle",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/search/title.scss";
</style>
